import PostalCodesFile from '@/common/models/postalCodesFiles/PostalCodesFile';
import GlobalEventBus from '@/GlobalEventBus';
import GlobalEvents from '@/GlobalEvents';
import API from '@/org-app/api';
import {
  createDeleteAction,
  createGetAllAction,
  createGetOneAction,
  createPostAction,
  createPutAction,
} from '@/utils/ActionsUtils';

import * as types from './mutation-types';

export default {
  createNewPostalCodesFile({ commit }, postalCodesFile = new PostalCodesFile()) {
    commit(types.CREATE_POSTAL_CODES_FILE, postalCodesFile);
    return postalCodesFile;
  },
  getPostalCodesFiles: createGetAllAction(
    API.instance.getPostalCodesFiles,
    types.UPDATE_POSTAL_CODES_FILES_LIST,
    'messages.failedToGetPostalCodesFiles',
    true,
  ),
  getPostalCodesFile: createGetOneAction(
    API.instance.getPostalCodesFile,
    types.UPDATE_POSTAL_CODES_FILE,
    'messages.failedToGetPostalCodesFiles',
  ),
  createPostalCodesFiles: createPostAction(
    API.instance.postPostalCodesFiles,
    types.SAVE_POSTAL_CODES_FILES,
    'messages.failedToCreatePostalCodesFiles',
  ),
  updatePostalCodesFile: createPutAction(
    API.instance.putPostalCodesFile,
    types.SAVE_POSTAL_CODES_FILES,
    'messages.failedToUpdatePostalCodesFiles',
  ),
  deletePostalCodesFile: createDeleteAction(
    API.instance.deletePostalCodesFile,
    types.DELETE_POSTAL_CODES_FILE,
    'messages.failedToDeletePostalCodesFiles',
  ),

  async uploadPostalCodesFile({ commit }, { name, file }) {
    GlobalEventBus.$emit(GlobalEvents.loading);
    try {
      return await API.instance.uploadPostalCodesFile({ name, file });
    } finally {
      GlobalEventBus.$emit(GlobalEvents.loaded);
    }
  },
};
